import React, { Fragment, useState } from "react";
import { Table, Button } from "react-bootstrap";
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import ProgressReport from "../Components/ProgressReport";
import Moment from 'react-moment';
import MultiProgressReport from "../Components/MultiProgressReport";

import { getProjectSummaryDetails } from '../../../store/actions/ProjectActions';
import { globalLoadingAction } from '../../../store/actions/GlobalAction';



const ReportGenerateTimeCard = (props) => {

    const dispatch = useDispatch();
    const projectDetails = useSelector((state) => state.project.projectDetails);
    const progressBarDetails = useSelector((state) => state.project.progressBarDetails || null);


    const [loading, setLoading] = useState(false);
    const [viewSummary, setViewSummary] = useState(false);
    const [showIndex, setShowIndex] = useState('');


    const handleDoubleClick = (index, isval) => {
        props?.editHandler(isval)
    }

    const onProjectSummaryHandler = async (project_id, index) => {
        try {
            if (showIndex === index && viewSummary) {
                // Collapse if same row clicked
                setViewSummary(false);
                setShowIndex(null);
            } else {
                // Expand new row
                setViewSummary(true);
                setShowIndex(index);

                // Show loader while fetching
                dispatch(globalLoadingAction(true));
                await dispatch(getProjectSummaryDetails(project_id, props?.reportId, props.history));
            }
        } catch (error) {
            console.error("Error fetching project summary:", error);
        } finally {
            dispatch(globalLoadingAction(false));
        }
    };





    return (
        <Fragment>
            {props.details ?
                <Table className='cart-table table-bordered mb-3'>
                    <thead>
                        <tr className='cart-table-header'>
                            <th colSpan={3}>
                                {/* <h4 className='timeSheet-project-title'>{props?.projectName}</h4> */}
                            </th>
                            <th>
                                <strong>Sun</strong>
                            </th>
                            <th>
                                <strong>Mon</strong>
                            </th>
                            <th>
                                <strong>Tue</strong>
                            </th>
                            <th>
                                <strong>Wed</strong>
                            </th>
                            <th>
                                <strong>Thr</strong>
                            </th>
                            <th>
                                <strong>Fri</strong>
                            </th>
                            <th>
                                <strong>Sat</strong>
                            </th>
                            <th className='text-center'>
                                <strong>Total Hrs</strong>
                            </th>

                        </tr>
                    </thead>

                    <thead>
                        <tr className='cart-table-header'>
                            <th>
                                <strong>Project</strong>
                            </th>

                            <th>
                                <strong>Activity</strong>
                            </th>
                            <th>
                                <strong>Task</strong>
                            </th>
                            {
                                props?.details?.time_table?.length > 0 &&
                                props?.details?.time_table.slice(0, 7).map((dates, dateIndex) => (
                                    <th key={dateIndex}>
                                        <strong>{dates.date}</strong>
                                    </th>
                                ))
                            }
                            <th className="text-center">
                                {props.isEdit && (
                                    props.isEditShow ? (
                                        <button
                                            type="button"
                                            className="btn btn-warning btn-xs"
                                            onClick={() => handleDoubleClick(0, false)}
                                        >
                                            <i className="fas fa-times"></i>
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-warning btn-xs"
                                            onClick={() => handleDoubleClick(0, true)}
                                        >
                                            <i className="fas fa-pencil-alt"></i>
                                        </button>
                                    )
                                )}
                            </th>


                        </tr>
                    </thead>
                    <tbody>
                        {
                            props?.details?.weeks_table?.length > 0 ? <>
                                {(props?.details?.weeks_table?.map((item, index, arr) => {
                                    const isLastInGroup =
                                        index === arr.length - 1 || item.project_unique_id !== arr[index + 1].project_unique_id;
                                    return (<>
                                        <tr key={index}>
                                            <td>
                                                <Link to="#"
                                                    onClick={() => props?.summaryHandler(item.project_id)}
                                                    className="view-summary-btn">{item.project_unique_id}</Link>
                                            </td>
                                            <td>{item.activity_id}</td>
                                            <td>{item.task_id}</td>
                                            {item.time_details?.slice(0, 7).map((times, timesIndex, arr) => (
                                                <td
                                                    className={`${times?.holiday ? "disable-column" : ""}`}
                                                    key={timesIndex}
                                                >
                                                    {(timesIndex === 0 || timesIndex === arr.length - 1) ? (
                                                        ''
                                                    ) : (
                                                        props?.isEditShow ? (
                                                            times?.holiday ? (
                                                                '0'
                                                            ) : (
                                                                <input
                                                                    className="timeEditable-control"
                                                                    onChange={(e) => props.changeHandler(e.target.value, index, timesIndex)}
                                                                    value={times.working_hour}
                                                                />
                                                            )
                                                        ) : (
                                                            times?.holiday ? (
                                                                '0'
                                                            ) : (
                                                                props.isLink && times.working_hour > 0 ? (
                                                                    <button
                                                                        className="time-link"
                                                                        onClick={() => props.getTimeDetails(timesIndex, item.task_id)}
                                                                    >
                                                                        {times.working_hour}
                                                                    </button>
                                                                ) : (
                                                                    times.working_hour
                                                                )
                                                            )
                                                        )
                                                    )}
                                                </td>
                                            ))}

                                            <td className='total-hrs'>{item.total_hour}</td>

                                        </tr>
                                        {/* onClick={() => props?.summaryHandler(item.project_id)} */}
                                        {/* {props.isSummary && isLastInGroup && (
                                            <tr key={`summary-${item.project_unique_id}-${index}`} className="summary-row">
                                                <td colSpan={10}>
                                                    <Link to="#"
                                                        
                                                        onClick={() => onProjectSummaryHandler(item.project_id, index)}
                                                        className="view-summary-btn">View Summary</Link>
                                                    {viewSummary && showIndex === index && (
                                                        <div className={`summary-content ${viewSummary && showIndex === index ? 'open' : ''}`}>
                                                            {loading ?
                                                                <p>Loading summary...</p>
                                                                :
                                                                <div className="sammary-container">
                                                                    {progressBarDetails?.legends?.length > 0 && (
                                                                        <div>
                                                                            <MultiProgressReport
                                                                                legends={progressBarDetails.legends}
                                                                                step={(progressBarDetails?.step ?? 0) - 2}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    <div className="sammary-group-view">
                                                                        <div className="sammary-label-group">
                                                                            <label className="sammary-label"><strong>ID</strong>: {projectDetails?.project_id}</label>
                                                                            <label className="sammary-label"><strong>Name</strong>: {projectDetails?.title}</label>
                                                                            <label className="sammary-label"><strong>Start Date</strong>: <Moment format="D MMM YYYY" withTitle>{projectDetails?.start_date}</Moment></label>
                                                                            <label className="sammary-label"><strong>End Date</strong>: <Moment format="D MMM YYYY" withTitle>{projectDetails?.end_date}</Moment></label>

                                                                        </div>
                                                                        <div className="sammary-label-group">
                                                                            <label className="sammary-label"><strong>Rate</strong>: {projectDetails?.rate}</label>
                                                                            <label className="sammary-label"><strong>Description</strong>: {projectDetails?.description}</label>
                                                                            <label className="sammary-label"><strong>Status</strong>: {projectDetails?.status == 1 ? "Active" : "Inactive"}</label>
                                                                            <label className="sammary-label"><strong>Type</strong>:    {(() => {
                                                                                switch (projectDetails?.project_type) {
                                                                                    case 1:
                                                                                        return 'Internal'
                                                                                    case 2:
                                                                                        return 'External'
                                                                                    default:
                                                                                        return null
                                                                                }
                                                                            })()}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            }
                                                        </div>
                                                    )}

                                                </td>
                                                <td className="total-hrs"></td>
                                            </tr>
                                        )} */}
                                    </>
                                    );
                                })
                                )} </> : (<tr className="table-row-nodata">
                                    <td colSpan={12} className="text-center">No data available</td>
                                </tr>
                            )}

                    </tbody>

                    <tbody>
                        <tr className='total-time'>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td colSpan={2}><strong>TOTAL HOURS :</strong></td>
                            <td className='total-hrs'><strong>{props.details?.total_hour}</strong></td>
                        </tr>
                    </tbody>
                </Table> : <div className="text-center mt-3">
                    <h3>No Data Found</h3>
                </div>}
        </Fragment>
    )
}

export default ReportGenerateTimeCard;